<app-toggle-group
    [options]="[
        { label: 'assetmanagement.tabs.documents' | transloco, value: 'documents' },
        {
            label: 'assetmanagement.tabs.hyperlinks' | transloco,
            value: 'hyperlinks',
            count: model.hyperlinks.length,
        },
    ]"
    [(selectedValue)]="selectedTab"
>
</app-toggle-group>

@switch (selectedTab) {
    @case ("documents") {}
    @case ("hyperlinks") {
        <app-asset-hyperlinks
            [model]="model"
            [canEdit]="canEdit"
            (hyperlinksChanged)="hyperlinksChanged.emit($event)"
        ></app-asset-hyperlinks>
    }
}
